import React, { Component } from 'react'
import { Card, Icon } from 'antd'

class NotFound extends Component {
  render() {
    return (
      <Card style={{
        width: '100%',
        height: '100%',
        backgroundColor: '#f0f2f5'
      }} bordered={false}>
        <Card style={{ fontSize: '24px', textAlign: 'center'}} bordered={false}>
          <Icon type="frown" /> <br /> <span>404 NOT FOUND</span>
        </Card>
      </Card>
    )
  }
}

export default NotFound
